// Terim seti: danışmanlık (diyetisyen, wellness). Anahtarlar clinical.js ile aynı.
const wellness = {
  patient: "Danışan",
  patients: "Danışanlar",
  patientGen: "Danışanın",
  patientDat: "Danışana",
  patientAcc: "Danışanı",
  patientLoc: "Danışanda",
  patientLower: "danışan",
  patientsLower: "danışanlar",
  patientGenLower: "danışanın",
  patientDatLower: "danışana",
  patientAccLower: "danışanı",
  patientAblLower: "danışandan",
  patientLocLower: "danışanda",
  patientIns: "Danışanla",
  patientInsLower: "danışanla",
  patientYourAccLower: "danışanınızı",
  patientsGen: "Danışanların",
  exam: "Görüşme",
  examLower: "görüşme",
  examAcc: "Görüşmeyi",
  examLoc: "görüşmede",
  examStart: "Görüşmeyi başlat",
  examComplete: "Görüşmeyi Tamamla",
  inExam: "Görüşmede",
  examDo: "Görüşme Başlat",
  doctor: "Uzman",
  doctorLower: "uzman",
  doctorPossLower: "uzmanı",
  firstVisit: "İlk görüşme",
  firstVisitTitle: "İlk Görüşme",
  followUp: "Kontrol",
  complaint: "Başvuru nedeni",
  patientNo: "Danışan No",
};
export default wellness;
